/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Attachment } from './attachment';
import type { AttachmentUploadResponseEtag } from './attachmentUploadResponseEtag';

/**
 * Response for the upload of an attachment
 */
export interface AttachmentUploadResponse {
  data: Attachment;
  /** New ETag of the module submission */
  etag?: AttachmentUploadResponseEtag;
}
